/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import emailConfirmationBoxStyle from "./emailConfirmationBoxStyle";
import {Box, Divider} from "@mui/material";
import Typography from "@mui/material/Typography";
import { useCustomer } from "../../../provider/Customer/CustomerProvider";

const EmailConfirmationBox = () => {
  const { customer } = useCustomer();

  if (customer === null || customer.verification !== null) {
    return null;
  }
  return (
    <Paper sx={emailConfirmationBoxStyle.container} elevation={4}>
      <Typography variant={"h4"} sx={emailConfirmationBoxStyle.headline}>
        Bitte bestätigen Sie Ihre E-Mail-Adresse!
      </Typography>
      <Divider sx={emailConfirmationBoxStyle.divider} />
      <Box sx={emailConfirmationBoxStyle.content}>
        <p>
          Klicken Sie hierzu auf den Link in der E-Mail, die wir Ihnen an{" "}
          <Box component={"span"} sx={{ wordBreak: "break-all" }} id={"hintbox-email"}>
            {customer.email}
          </Box>{" "}
          geschickt haben. Schauen Sie hierzu ggf. auch in Ihren SPAM-Ordner. Wenn Sie Ihre E-Mail bestätigt haben, können Sie alle Funktionen der Servicewelt
          nutzen.
        </p>
      </Box>
    </Paper>
  );
};

export default EmailConfirmationBox;
